import OrdersTable from "./OrdersTable";

export default function InProgress() {
  return <OrdersTable type="in-progress" />;
}
